// Acordeones de las secciones de Gestión: título negro y sin animación, como
// el resto de la plataforma. Se usa junto con transitionOptions={{ timeout: 0 }}.
export const estiloAccordion = {
  "& .p-accordion-header-link": { color: "black !important" },
  "& .p-toggleable-content": { transition: "none !important" },
};
